<template>
    <modal
        name="crearDescuento"
        transition="pop-out"
        :width="800"
        height="auto"
        :scrollable="true"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2>Crear nuevo precio</h2>
                    </div>
                    <div class="col-2">
                        <button type="button" class="close" @click.prevent="close(false)">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <FormDescuento :descuento="descuento" v-on:terminado=" (descuento) => crearPrecio(descuento)"/>
            </div>
            <div class="card-footer text-right">
                <Button type="button" name="button" @click.prevent="close(false)" :disabled="loading">CERRAR</Button>
            </div>
        </div>
    </modal>
</template>

<script>

    import FormDescuento from './FormDescuento';

    export default {
        props: ['lista_id', 'precio_id'],
        data() {
            return {
                loading: false,
                descuento: {}
            }
        },
        methods: {
            close(creado) {
                this.$emit('close', 'crearDescuento', creado);
            },
            crearPrecio(descuento) {
                this.loading = true;

                descuento.filters = {};
                descuento.lista_id = this.lista_id;
                descuento.precio_id = this.precio_id;

                this.$store.dispatch(this.config.getVuexAlias('back.precios.descuentos.crear'), descuento).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            }
        },
        components: {
            FormDescuento
        }
    }
</script>